import httpClient from '@/shared/http-tms-client';
import { formatDate } from '@/utils/report-utils';

const getRegistrationStatus = () => httpClient.get('/Reports/RegistrationStatus');
const getOnHoldes = () => httpClient.get('/Reports/OnHoldes');
const getFacilityStatus = () => httpClient.get('/Reports/FacilityStatus');
const getReportSites = (jurisdiction, facilityStatusType, registrationStatusType, onholdString, registrationDesc) => httpClient.get(`/Reports/RptSitesOnhold?jurisdiction=${jurisdiction}&facilityStatusType=${facilityStatusType}&registrationStatusType=${registrationStatusType}&onholdString=${onholdString}&registrationDesc=${registrationDesc}`);
const getRegistrationList5 = () => httpClient.get('/Registration/OperationalPermitFeeList5');

const getWorkPermitReports = (permitType, permitStatus, startDate, endDate) => {
  const permitTypeParam = `permitType=${permitType}`;
  const permitStatusParam = `permitStatus=${permitStatus}`;
  const startDateParam =`startDate=${startDate ? formatDate(startDate) : ''}`;
  const endDateParam =`endDate=${endDate ? formatDate(endDate) : ''}`;
  console.log('url', `/Reports/RptWorkPermits?${permitTypeParam}&${permitStatusParam}&${startDateParam}&${endDateParam}`)
  return httpClient.get(`/Reports/RptWorkPermits?${permitTypeParam}&${permitStatusParam}&${startDateParam}&${endDateParam}`);
};

const getOperationgPermitReports = (invoiceStatusType, registrationID, certificateType, registrationStatusType) => httpClient.get(`/Reports/RptOperatingPermits?invoiceStatusType=${invoiceStatusType}&registrationID=${registrationID}&certificateType=${certificateType}&registrationStatusType=${registrationStatusType}`);

const getInspectionReports = (actualInspectionDateStart, actualInspectionDateEnd, vocDateStart, vocDateEnd) => {
  const aiStartDateParam = `actualInspectionDateStart=${actualInspectionDateStart ? formatDate(actualInspectionDateStart) : ''}`;
  const aiEndDateParam = `actualInspectionDateEnd=${actualInspectionDateEnd ? formatDate(actualInspectionDateEnd) : ''}`;
  const vocStartDateParam = `vocDateStart=${vocDateStart ? formatDate(vocDateStart) : ''}`;
  const vocEndDateParam = `vocDateEnd=${vocDateEnd ? formatDate(vocDateEnd) : ''}`;
  console.log('url', `/Reports/RptInspections?${aiStartDateParam}&${aiEndDateParam}&${vocStartDateParam}&${vocEndDateParam}`)
  return httpClient.get(`/Reports/RptInspections?${aiStartDateParam}&${aiEndDateParam}&${vocStartDateParam}&${vocEndDateParam}`);
};

export {
  getRegistrationStatus,
  getOnHoldes,
  getFacilityStatus,
  getReportSites,
  getRegistrationList5,
  getWorkPermitReports,
  getOperationgPermitReports,
  getInspectionReports,
};
